import {Component, OnInit} from '@angular/core';
import {Fmt} from '../../fmt.service';
import {Auth} from '../../auth.service';
import {ProjectTemplateService, ProjectTemplate, AllowedWorkspace} from './projectTemplates.service';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { WsUsageFIlter } from '../wsusage/wsusage.filter';
import { DateTime } from 'luxon';

@Component({
    selector: 'project_template',
    templateUrl: './projectTemplates.component.html',
    styleUrls: ['./../app/app.component.css'],
    providers: [
        Fmt,
        WsUsageFIlter,
        ProjectTemplateService
    ]
})

export class ProjectTemplateComponent implements OnInit {
    public pjTemplates: ProjectTemplate[] = [];
    public tableFilter: any = "";
    public workspacesToShare: AllowedWorkspace[] = [];
    public currentPJTemplateEdit: ProjectTemplate = {
        tp_id :"",
        description:"",
        category:"",
        enabled:false,
        scope: "",
        allowed_workspaces: [],
        name:"",
        p_id:"",
        w_id:"",
        d_ids:[],
        deleted_by: "",
        deleted_at: "",
    };
    public selectedScope: string = "private";
    public enabledCheck: boolean = false;
    public selectedWs: [] = [];
    public canEditTableColumns = [];

    public updateSettingsModal: boolean = false;
    public templateSettingsModal: FormGroup = <FormGroup>{};
    public newEditableLabels: Array<any> = []
    public targetPjTemplate: ProjectTemplate = {} as ProjectTemplate;
    private nzPageSize: number = 30;

    constructor(public _fmt: Fmt,
                public fb: FormBuilder,
                public _pjTemplateService: ProjectTemplateService) {
        this.loadPJTemplates();
    }

    ngOnInit(): void {
        this.canEditTableColumns = this.initCanEditTableColumns();
        this.utilsBuildColSettings('templateSettingsModal', this.newEditableRow(this.tableColumns));

        this.newEditableLabels = this.tableColumns.map(item => {
            if(item.updateable) return {
                key: item.key,
                type: item.type
            };
        })
    }

    public tableColumns = [
        {name: "カテゴリー", key: "category", showlist: true, updateable: true, type: "text", formGroup: false, modal: true},
        {name: "テンプレート名", key: "name", showlist: true, updateable: true, type: "text", formGroup: false, modal: true},
        {name: "説明", key: "description", showlist: true, updateable: true, type: "textarea", formGroup: false, modal: true},
        {name: "有効", key: "enabled", showlist: true, updateable: true, type: "checkbox", formGroup: false, modal: true},
        {name: "作成元ワークスペース", key: "ws_name", showlist: true, updateable: false, formGroup: false, modal: false},
        {name: "利用可能範囲", key: "scope", showlist: true, updateable: false, formGroup: false, modal: false},
        {name: "利用可能ワークスペース", key: "allowed_workspaces", showlist: true, updateable: true, type: "text", formGroup: false, modal: false},
        {name: 'selectedScope', key: "selectedScope", showlist: false, updateable: false, formGroup: false, modal: false},
        {name: 'selectedScopeItems', key: "selectedScopeItems", showlist: false, updateable: false, formGroup: true, modal: false}
    ];

    public initCanEditTableColumns = () => this.tableColumns.filter(col => col.showlist === true);

    public scopeNames = [
        {id: "private", name: "非公開", desc: "作成したワークスペース内でのみ利用可能になります", showDlg: false},
        {id: "public", name: "公開", desc: "すべてのワークスペースで利用可能になります", showDlg: false},
        {id: "select", name: "選択して公開", desc: "指定したワークスペースのみテンプレートが利用可能になります", showDlg: true},
    ];
    private scopeNoneName = "(未設定)";

    public loadPJTemplates() {
        this._pjTemplateService.LoadPJTemplates<Array<ProjectTemplate>>().subscribe(
            result => {
                let data = result;
                this.pjTemplates = data;
            }
        )
    }

    public getScopeName(scopeId: string) {
        let scopeName = this.scopeNames.find(scope => scope.id === scopeId);
        return (scopeName) ? scopeName.name : this.scopeNoneName
    }

    public openUpdateTpl(currentTPL: ProjectTemplate) {
        this.currentPJTemplateEdit = currentTPL;
    }

    public saveTplNames(): void {
        let params = <Object>{
            tp_id: this.currentPJTemplateEdit.tp_id,
            name: this.currentPJTemplateEdit.name,
            category: this.currentPJTemplateEdit.category,
            description: this.currentPJTemplateEdit.description,
        };
        this._pjTemplateService.UpdatePJTemplateNames(params).subscribe(
            result => {
                this.loadPJTemplates();
                // this._fmt.log("Update succeeded!");
            },
            err => {
                this._fmt.log("Error on saveTplNames");
            }
        )
    }

    private newEditableRow = (targetCols: any, suffix?: string) => targetCols.map(item => `${item.key}`)


    private utilsBuildColSettings = (targetForm: string, cols: Array<string>, preloadVal?: any) => {
        var targetCol = {}
        for(const key of cols) {
            var tf = this.tableColumns.find(item => item.key === key);
            if(tf['formGroup']) {
                targetCol[key] = this.fb.group(<object>{});
                // continue
            }

            if(!targetCol[key]) {
                targetCol[key] = [preloadVal ? preloadVal[key] : null, [Validators.required]]
            }
                        
        }
        this[targetForm] = this.fb.group(targetCol);
    }
    
    public editableRowCols = [

    ]
    public updateSettingsModalAction = (pjTemplate: any) => {
        this.updateSettingsModal = !this.updateSettingsModal;
        if(!pjTemplate) return;

        var targetSettings = this.templateSettingsModal.value;
        var updatedValues = {...pjTemplate, ...targetSettings};
        
        let params = <Object>{
            tp_id: updatedValues.tp_id || pjTemplate ? pjTemplate.tp_id : null,
            name: updatedValues.name || pjTemplate.name,
            category: updatedValues.category || pjTemplate.category,
            description: updatedValues.description || pjTemplate.description,
            enabled: updatedValues.enabled,
            scope: this.selectedScope
        };

        if(this.workspacesToShare && this.workspacesToShare != [])
        {
            params['allowed_workspaces'] = this.workspacesToShare.filter(ws => ws.can_use === true);
        };

        if (!updatedValues.enabled) {
            params['disabled_at'] = DateTime.utc().toISO();
        }

        this.targetPjTemplate = updatedValues;
        this._pjTemplateService.UpdatePJTemplateNames(params).subscribe(
            result => {
                this.loadPJTemplates();
                // this._fmt.log("Update succeeded!");
            },
            err => {
                this._fmt.log("Error on saveTplNames");
            }
        )        
    }

    public openUpdateSettingsModal = (pjTemplate: any) => {
        if (pjTemplate["deleted_by"] != null) {
            return
        }
        this.updateSettingsModal = !this.updateSettingsModal;
        this.targetPjTemplate = pjTemplate;
        this.utilsBuildColSettings('templateSettingsModal', this.newEditableRow(this.tableColumns), pjTemplate)
        this.openPJTplScope(pjTemplate)
    }

    public openEnableTpl(currentTPL: ProjectTemplate) {
        this.enabledCheck = currentTPL.enabled;
        this.currentPJTemplateEdit = currentTPL;
    }
    public saveEnableTpl(): void {
        let params = <Object>{
            tp_id: this.currentPJTemplateEdit.tp_id,
            enabled: this.enabledCheck,
        };
        this._pjTemplateService.EnablePJTemplate(params).subscribe(
            result => {
                this.loadPJTemplates();
            },
            err => {
                this._fmt.log("Error on saveEnableTpl");
            }
        )
    }

    public openPJTplScope(currentTPL: ProjectTemplate) {
        this.selectedScope = currentTPL.scope;
        // this.workspacesToShare = currentTPL.allowed_workspaces;
        this.getSelectWStoShare(currentTPL, (data) => {
            if (data.status == 200) {
                this.workspacesToShare = data['workspaces'];
                if(!this.workspacesToShare || this.workspacesToShare == []) return;

                this.workspacesToShare.forEach((ws)=> {
                    currentTPL.allowed_workspaces.forEach((canUseWs)=>{
                        if (ws["w_id"] === canUseWs["w_id"]) {
                            ws.can_use = true;
                        }
                        ws['label'] = ws.name;
                        ws['value'] = ws.name
                    })
                });
                this.currentPJTemplateEdit = currentTPL;
            } else {

            }
        })
    }

    public saveChangeScope(): void {

        if (this.selectedScope == "select") {
            if (this.currentPJTemplateEdit.allowed_workspaces && this.currentPJTemplateEdit.allowed_workspaces.length != 0) {
                this.currentPJTemplateEdit.allowed_workspaces = [];
            }
            for (let ws in this.workspacesToShare) {
                let canUse = this.workspacesToShare[ws]['can_use'];
                if (canUse){
                    this.currentPJTemplateEdit.allowed_workspaces.push(
                        {
                            'w_id': this.workspacesToShare[ws]['w_id'],
                            'name': '',//do not save ws name
                            'can_use': canUse,
                        }
                    )
                }
            }
        }

        let params = <Object>{
            tp_id: this.currentPJTemplateEdit.tp_id,
            scope: this.selectedScope,
            allowed_workspaces: this.currentPJTemplateEdit.allowed_workspaces,
        };

        this._pjTemplateService.UpdatePJTemplate(params).subscribe(
            result => {
                this.loadPJTemplates();
                // this._fmt.log("Update succeeded!");
            },
            err => {
                this._fmt.log("Error on saveChangeScope ");
            }
        )
    }

    public getSelectWStoShare(currentTPL: any, callback: (data: any) => void) {
        console.log(222)
        this._pjTemplateService.GetSelectWSToShare(currentTPL['tp_id']).subscribe(
            result => {
                let data = result;

                callback(data);
            }
        )
    }
}